<template>
  <!--配料附加费-->
  <div>
    <s-pageheader title="配样附加费" />
    <ak-model-filter-card model="parts" @search="search" @reset="reset" :perPage="30" />
    <!--附加费-->
    <ak-model-tree
      :treeSpan="4"
      model="batchingSurcharge"
      treeModel="finishWorkShop"
      parentKey="parentNode"
      pointerToTree="proportion"
      treeTitle="车间检索"
      @selected="getTree"
      :action="edit"
      :modelTableProps="modelTableProps"
      :perPage="30"
    />
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader/PageHeader'
import editSurcharge from '@/core/components/editSurcharge'
import { mapState } from 'vuex'

export default {
  components: {
    's-pageheader': PageHeader
  },
  data () {
    return {
      edit: { // 覆盖model的action
        create: false,
        edit: {
          title: '编辑附加费',
          component: editSurcharge
        }
      },
      modelTableProps: {
        perPage: 30,
        page: 1,
        filters: {}
      },
    }
  },
  computed: {
    ...mapState([
      'user'
    ])
  },
  methods: {
    search (filters) {
      this.$set(this.modelTableProps, 'filters', filters)
      this.$set(this.modelTableProps, 'page', 1)
    },
    reset () {
      this.$set(this.modelTableProps, 'filters', {})
      this.$set(this.modelTableProps, 'page', 1)
    },
    // 监听树节点选中状态
    getTree (obj) {
      // 根据选中的节点判断新建按钮是否显示
      if (obj.length === 1 && obj[0].record.type === 'ratio') {
        this.edit.create = {
          text: '添加附加费',
          classify: 'batching',
          type: 'list',
          buttonType: 'primary', // 按钮的类型
          proportion: obj[0].key,
          modelId: obj[0].parentNode.key,
          workShop: obj[0].record.workShop.objectId,
          component: editSurcharge
        }
      } else {
        this.edit.create = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
  ::v-deep .node-icon:before {
    content: none !important;
  }
</style>
